module.exports = __webpack_public_path__ + "static/media/icon_collapse.a5dc0359.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon_collapse.svg
// module id = 274
// module chunks = 0